import { render, staticRenderFns } from "./addUserGroup.vue?vue&type=template&id=5354877d&scoped=true"
import script from "./addUserGroup.vue?vue&type=script&lang=js"
export * from "./addUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354877d",
  null
  
)

export default component.exports